<template>
  <div v-if="userData?.isSuperAdmin" class="flex overflow-hidden flex-grow bg-trader-gray ">
    
    <div class="overflow-hidden flex flex-col flex-grow mr-2">

      <!-- Hauptbereich -->
      <div class="flex-grow overflow-hidden px-10 h-full flex flex-col p-4 bg-white">
        <!-- Titel und Name -->
        <div class="flex-shrink-0 flex items-center justify-between w-full h-10  rounded">
          <div class="w-full text-center rounded">
            <span class="text-xl font-semibold">SQL Befehl Manager</span>
          </div>
        </div>


        <div class="mb-4">
          <!-- Header mit Name und Icons auf gleicher Höhe -->
          <div class="flex items-center justify-between  p-1  rounded-t-md ">
            <!-- Name Section -->
            <div class="flex items-center gap-3 flex-1 max-w-md">
              <label for="statementName" class="text-sm font-medium text-trader-text whitespace-nowrap">
                Statement Name:
              </label>
              <input
                  id="statementName"
                  v-model="statementName"
                  type="text"
                  class="px-2 flex-grow  py-0.5"
                  placeholder="Geben Sie einen Namen ein..."
                  ref="nameInput"
              >
            </div>

            <!-- Action Icons -->
            <div class="flex items-center gap-4">
              <!-- Execute Button -->
              <button
                  @click="executeSql"
                  :disabled="isExecuting"
                  class="p-2 rounded-full  transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                  data-ui="execute-sql-button"
                  title="SQL ausführen">
                <i class="fas fa-play text-green-600 text-lg"></i>
              </button>

              <!-- Save Statement -->
              <button
                  @click="openSaveModal"
                  class="p-2 rounded-full hover:bg-trader-green/10 transition-colors duration-200"
                  title="Statement speichern">
                <i class="fa-solid fa-plus text-trader-green text-lg"></i>
              </button>

              <!-- Save Results -->
              <button
                  @click="updateStatement"
                  class="p-2 rounded-full  transition-colors duration-200"
                  title="Ergebnisse speichern">
                <i class="fa-solid fa-floppy-disk text-blue-600 text-lg"></i>
              </button>

              <!-- Clear Results -->
              <button
                  @click="resultData = null"
                  class="p-2 rounded-full  transition-colors duration-200"
                  title="Ergebnisse löschen">
                <i class="fa-solid fa-xmark text-red-600 text-lg"></i>
              </button>
            </div>
          </div>

          <!-- Code Editor -->
          <CodeEditor v-model="statement"
                      :header="false"
                      :languages="[['sql']]"
                      class="flex-grow"
                      :width="'100'"
                      :borderRadius="false"
                      :font-size="'12px'"/>
        </div>
        <!-- Text Response -->
        <div v-if="!resultData" class="  flex flex-col gap-2 text-white">
          <div class="flex gap-2 bg-trader-darkest-gray  px-2 py-1" v-for="s in statements"
               @click="statement = s.statement; statementId = s.id; statementName = s.name">
            <span>Name:</span>
            <span>{{ s.name }}</span>
          </div>
        </div>

        <div v-if="responseText && !resultData"
             class="bg-gray-50 p-4 bg-trader-dark-gray dark:bg-trader-gray rounded  ">
          <pre class="text-sm whitespace-pre-wrap ">{{ responseText }}</pre>
        </div>
        <!-- Tabellen Response -->
        <div v-if="resultData" class="flex overflow-auto flex-grow">
          <table class="w-full text-left">
            <thead class="bg-trader-dark-gray sticky top-0 ">
            <tr class="border-b-2 dark:border-trader-gray">
              <th class="p-2  border-r border-trader-gray">#</th>
              <th v-for="column in resultData.columns" :key="column" class="p-2 border-r border-trader-gray">
                {{ column }}
              </th>
              <th class="w-full"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, index) in resultData.rows" :key="index" class="border-b-2 dark:border-trader-gray">
              <td class="p-2  border-r border-trader-gray">{{ index + 1 }}</td>
              <td v-for="(cellValue, cellIndex) in row" :key="cellIndex" class="p-2 border-r border-trader-gray">
                <span class="px-1  ">{{ cellValue }}</span>
              </td>
              <td class="w-full"></td>
            </tr>
            </tbody>
          </table>
        </div>


        <!-- Placeholder wenn keine Daten -->
        <div v-else class="flex-grow flex items-center justify-center text-gray-400">
          <div class="text-center">
            <p class="text-lg">Führen Sie einen SQL-Befehl aus um Ergebnisse zu sehen</p>
          </div>
        </div>

      </div>
    </div>

    <!-- Save Modal -->
    <div v-if="showSaveModal" class="fixed inset-0  bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white rounded-lg p-6 w-96 max-w-md mx-4 shadow-xl">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-lg font-semibold text-trader-text">SQL Statement speichern</h3>
          <button @click="closeSaveModal" class="text-trader-text ">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="mb-4">
          <label for="statementName" class="block text-sm font-medium text-trader-text mb-2">
            Name des Statements
          </label>
          <input
              id="statementName"
              v-model="statementName"
              type="text"
              class="w-full px-3 py-2 border  rounded-md focus:outline-none focus:ring-2 focus:ring-trader-green focus:border-transparent"
              placeholder="name"
              @keyup.enter="saveStatement"
              ref="nameInput"
          >
        </div>

        <div class="flex justify-end gap-3">
          <button
              @click="closeSaveModal"
              class="px-4 py-2 text-trader-text  rounded-md hover:bg-gray-200 transition duration-200"
          >
            Abbrechen
          </button>
          <button
              @click="saveStatement"
              :disabled="!statementName.trim()"
              class="px-4 py-2 bg-trader-green text-trader-dark-green rounded-md hover:bg-green-700 transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Speichern
          </button>
        </div>
      </div>
    </div>

    <!-- Sidebar -->
    <Sidebar/>
  </div>
</template>

<script setup>
import {computed, nextTick, onMounted, ref} from "vue";
import Sidebar from "@/components/Administration/Sidebar.vue";
import {mutation, query} from "@/graphql";
import CodeEditor from "simple-code-editor";
import "highlight.js/styles/github.css";
import {useRoute} from "vue-router";
import {useStore} from "vuex";
const store = useStore();
const userData = computed(() => store.state.user.userData);
// Reactive references
const route = useRoute();
const statement = ref('');
const responseText = ref('');
const resultData = ref();
const executionDuration = ref(0);
const isExecuting = ref(false);
const showError = ref(false);
const statements = ref([]);

// Modal references
const showSaveModal = ref(false);
const statementName = ref('');
const nameInput = ref(null);

// Methods
const executeSql = async () => {
  console.log("Executing SQL command:", statement.value);
  const [data, err] = await mutation.executeSqlCommand(statement.value);
  resultData.value = data;

  if (err) {
    console.error("Error executing SQL command:", err);
    responseText.value = `Fehler: ${err.message || err}`;
    showError.value = true;
    resultData.value = null;
  }
};

// Modal methods
const openSaveModal = () => {
  showSaveModal.value = true;
  statementName.value = '';
  nextTick(() => {
    nameInput.value?.focus();
  });
};

const closeSaveModal = () => {
  showSaveModal.value = false;
  statementName.value = '';
};

const saveStatement = async () => {

  const [_, err] = await mutation.createStatement(0, statementName.value, statement.value);
  if (err) {
    console.error("Error saving statement:", err);
    return;
  }
  showSaveModal.value = false;

};

const statementId = ref(0)
const updateStatement = async () => {

  const [_, err] = await mutation.createStatement(statementId.value, statementName.value, statement.value);
  if (err) {
    console.error("Error saving statement:", err);
    return;
  }
  showSaveModal.value = false;
  await getStatements();

};

const getStatements = async () => {
  const [data, err] = await query.getStatements();
  if (err) {
    console.error("Error fetching statements:", err);
    return;
  }
  statements.value = data;
};
onMounted(async () => {
  await getStatements();
});


</script>